import { getMidpointIcon } from "./googlemapicon";

export function getMidpointMarker(map: google.maps.Map, loc: google.maps.LatLng) {
    const marker = new google.maps.Marker({
        map: map,
        icon: getMidpointIcon(),
        animation: google.maps.Animation.DROP,
        position: loc
    });

    return marker;
}
